module.exports = __webpack_public_path__ + "static/media/Group9235.f259221b.png";